angular.module('elfium').controller('dashboardFilterController', ['$scope', 'elfiumLoginService', 'elfiumRelatedOptionsService', 'elfiumToastrService',
    function ($scope, elfiumLoginService, elfiumRelatedOptionsService, elfiumToastrService) {
        var that = this;
        $scope.localFilter = null;
        that.init = function () {
            $scope.filter = $scope.filter || {};
            $scope.filter.user = elfiumLoginService.getUserId();
            $scope.localFilter = angular.copy($scope.filter);
            that.getRelatedOptions();
        };
        that.getRelatedOptions = function () {
            elfiumRelatedOptionsService.getUserOptions().then(function (userOptions) {
                $scope.userOptions = userOptions;
            }, elfiumToastrService.error);
        };   
        $scope.updateValues = function () {
            $scope.filter = angular.copy($scope.localFilter);
        };
        that.init();
    }
]); 


// WEBPACK FOOTER //
// ./src/app/components/dashboard/dashboardFilterController.ts